import { get } from "svelte/store";
import {
  user,
} from "../stores";
import { querystring, push, pop, location } from "svelte-spa-router";


export async function checkLogin() {
    let u = get(user);
    if (!u) {
      let loc = get(location);
      let qs = get(querystring);
      if (qs.search("showAuth=true") == -1) {
        if (!qs) {
          push(loc + "?showAuth=true");
        } else push(loc + qs + "&showAuth=true");
      }
      return false;
    }
    return true;
  }